var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAccountBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13.5A4.5,4.5,0,1,1,18,9,4.494,4.494,0,0,1,22.5,13.5ZM9,25.5c0-3,6-4.65,9-4.65s9,1.65,9,4.65V27H9Z",
    transform: "translate(-8.5 -8.5)",
    fill: "none",
    stroke: "#2d2d33",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAccountBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-account-box.133f9d33.svg";
export { ForwardRef as ReactComponent };